// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__05AHm","title":"styles_title__P1+Tx","description":"styles_description__i0NvJ","form":"styles_form__VtjoH","forgot":"styles_forgot__G62Gn"};